/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  activateStrongCustomerAuthentication:
    "Activate strong customer authentication.",
  dashboard: "Dashboard",
  setupExtraSecurity: "Setup extra security",
  setupNow: "Set up now",
};
